import { useMemo, useState, useEffect } from "react";
import "./enterInfoPage.css";

function EnterInfoPage() {
  const goInstagram = () =>
    window.open(
      "https://www.instagram.com/hkcs.superdaddy?igsh=MXV0bWV5dnRkM3Zncg%3D%3D&wa_status_inline=true",
      "_blank",
      "noopener,noreferrer",
    );

  const goWhatsappGroup = () =>
    window.open(
      "https://chat.whatsapp.com/KxZqcmfAF0808UupYpBt6c",
      "_blank",
      "noopener,noreferrer",
    );
  const goDetailResultPage = () => window.location.assign("/detail-result");

  const searchParams = useMemo(
    () => new URLSearchParams(window.location.search),
    [],
  );
  const recordIdParam = searchParams.get("recordId");

  const [name, setName] = useState("");
  const [nameLoading, setNameLoading] = useState(!!recordIdParam);

  useEffect(() => {
    if (!recordIdParam) return;
    setNameLoading(true);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || "/api";
    const requestBase = apiBaseUrl.startsWith("http")
      ? apiBaseUrl
      : `${window.location.origin}${apiBaseUrl}`;
    const url = new URL(`${requestBase}/records/${recordIdParam}`);
    fetch(url.toString())
      .then((res) => res.json())
      .then((data) => {
        if (data && data.success && data.data && data.data.name) {
          setName(data.data.name);
        }
      })
      .finally(() => setNameLoading(false));
  }, [recordIdParam]);
  const [childrenCount, setChildrenCount] = useState("");
  const [phone, setPhone] = useState("");
  const [mail, setMail] = useState("");
  const [notify, setNotify] = useState("");
  const [formError, setFormError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const preventSubmit = (event) => event.preventDefault();

  function validateFormFields() {
    const trimmedName = name.trim();
    const trimmedMail = mail.trim();
    const trimmedPhone = phone.trim();

    if (!trimmedName) {
      return "請填寫姓名。";
    }

    if (!childrenCount) {
      return "請選擇你有幾位子女。";
    }

    if (!trimmedMail) {
      return "請填寫電郵。";
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(trimmedMail)) {
      return "電郵格式不正確，請重新輸入。";
    }

    if (trimmedPhone) {
      const phoneAllowedPattern = /^[0-9+()\-\s]+$/;
      if (!phoneAllowedPattern.test(trimmedPhone)) {
        return "聯絡電話只可包含數字、+、()、- 或空格。";
      }
    }

    if (!notify) {
      return "請選擇是否接收活動通知。";
    }

    return "";
  }

  async function handleApply() {
    const parsedRecordId = Number(recordIdParam);

    if (!recordIdParam || !Number.isFinite(parsedRecordId)) {
      setFormError("缺少 recordId，請先完成測驗流程。");
      return;
    }

    const validationError = validateFormFields();
    if (validationError) {
      setFormError(validationError);
      return;
    }

    setFormError("");
    setIsSubmitting(true);

    try {
      const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || "/api";
      const requestBase = apiBaseUrl.startsWith("http")
        ? apiBaseUrl
        : `${window.location.origin}${apiBaseUrl}`;
      const url = new URL(`${requestBase}/records/${parsedRecordId}/profile`);

      const response = await fetch(url.toString(), {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: name.trim(),
          childrenCount,
          phone: phone.trim() || null,
          mail: mail.trim(),
          subscribe: notify === "yes" ? 1 : 0,
          followUpRequired: notify === "yes" ? 1 : 0,
        }),
      });

      const contentType = response.headers.get("content-type") || "";
      const responseBody = contentType.includes("application/json")
        ? await response.json()
        : { success: false, message: await response.text() };

      if (!response.ok || !responseBody.success) {
        throw new Error(responseBody.message || "更新資料失敗");
      }

      goDetailResultPage();
    } catch (error) {
      setFormError(error.message || "更新資料失敗");
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <main className="enter-info-page">
      <div className="enter-info-page-bg" />

      <section className="enter-info-card">
        <img className="enter-info-paper-bg" src="/images/P8_Banner_01.webp" />

        <div className="enter-info-content">
          <div className="enter-info-hero">
            <img
              className="enter-info-hero-text"
              src="/images/P8_Banner_Text_01.webp"
            />
          </div>

          <div className="enter-info-intro">
            <div className="enter-info-title">
              正在懸賞<span className="enter-info-title-number">5</span>位船長
            </div>
            <img
              className="enter-info-thumbnail"
              src="/images/P8_5PPL_01.webp"
            />
          </div>

          <div className="enter-info-description">
            <div className="description">
              每一位船長，
              <br />
              都代表一種不同級別的爸爸力量。
              <br />
              而你，正是我們正在尋找的其中一位船長。
            </div>
          </div>

          <div className="enter-info-body">
            <img className="description-deco" src="/images/P8_Deco_01.webp" />

            <form className="enter-info-form" onSubmit={preventSubmit}>
              <div className="enter-info-form-row">
                <label htmlFor="name-input">姓名：</label>
                <input
                  id="name-input"
                  type="text"
                  value={name}
                  disabled
                  readOnly
                  style={{ background: nameLoading ? "#eee" : undefined }}
                />
              </div>

              <div className="enter-info-form-row enter-info-form-radio-row children-count-row">
                <div className="enter-info-radio-question">你有幾位子女？</div>
                <div className="enter-info-radio-group children-count-group">
                  <label>
                    <input
                      type="radio"
                      name="childrenCount"
                      value="expecting"
                      checked={childrenCount === "expecting"}
                      onChange={(event) => setChildrenCount(event.target.value)}
                    />
                    準爸爸
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="childrenCount"
                      value="one"
                      checked={childrenCount === "one"}
                      onChange={(event) => setChildrenCount(event.target.value)}
                    />
                    1位
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="childrenCount"
                      value="twoOrMore"
                      checked={childrenCount === "twoOrMore"}
                      onChange={(event) => setChildrenCount(event.target.value)}
                    />
                    2位或以上
                  </label>
                </div>
              </div>

              <div className="enter-info-form-row">
                <label htmlFor="phone-input">聯絡電話（可選填）：</label>
                <input
                  id="phone-input"
                  type="tel"
                  value={phone}
                  onChange={(event) => setPhone(event.target.value)}
                />
              </div>

              <div className="enter-info-form-row">
                <label htmlFor="email-input">電郵：</label>
                <input
                  id="email-input"
                  type="email"
                  value={mail}
                  onChange={(event) => setMail(event.target.value)}
                />
              </div>

              <div className="enter-info-form-row enter-info-form-radio-row">
                <div className="enter-info-radio-question">
                  你想收到我們的活動通知嗎？
                </div>
                <div className="enter-info-radio-group">
                  <label>
                    <input
                      type="radio"
                      name="notify"
                      value="yes"
                      checked={notify === "yes"}
                      onChange={(event) => setNotify(event.target.value)}
                    />
                    想
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="notify"
                      value="no"
                      checked={notify === "no"}
                      onChange={(event) => setNotify(event.target.value)}
                    />
                    不想
                  </label>
                </div>
              </div>
            </form>

            {formError ? (
              <p className="enter-info-form-error">{formError}</p>
            ) : null}

            <div className="btn-container">
              <div className="btn-description">領取更多升呢資訊</div>
              <button type="button" onClick={goWhatsappGroup} className="btn">
                <img src="/images/P8_WtsButton_01.webp" />
              </button>
              <button type="button" onClick={goInstagram} className="btn">
                <img src="/images/P8_IGButton_01.webp" />
              </button>
              <div className="btn-apply-column">
                <button
                  type="button"
                  onClick={handleApply}
                  className="btn btn-apply"
                  disabled={isSubmitting}
                >
                  <img src="/images/P8_ApplyButton_01.webp" />
                </button>
                <div className="submit-description">
                  備註：資料只會用於了解你的測驗結果及通知相關活動，不會作其他用途。
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default EnterInfoPage;
